import { COLORS } from '@/constants';
import { Card } from '@mui/material';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
  border-radius: 8px !important;
  overflow: hidden;
  padding: 0;
  flex-shrink: 0;
  min-height: fit-content;
  transition: opacity 0.2s ease;
  border: none !important;
  outline: none !important;
  height: 100%;
  display: flex !important;
  flex-direction: column !important;
`;

export const StyledImage = styled.img`
  width: 100%;
  height: 100% !important;
  max-height: 220px;
  min-height: 220px;
  object-fit: cover;
  overflow: hidden;
`;

export const ImageWrapper = styled.div<{ $borderless: boolean; $isProject?: boolean }>`
  height: 220px;
  position: relative;
  background: #eeeeee;
  transition: filter 0.2s ease;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
`;

export const ButtonsBox = styled.div`
  position: absolute;
  top: 8px;
  gap: 8px;
  right: 8px;
  display: flex;
  flex-direction: row;
  z-index: 20;
`;

export const CardContent = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  padding: 14px;
  text-align: start;
  border: 1px solid ${COLORS['neutral/300']};
  border-top: none;
  border-radius: 0 0 8px 8px;
  flex: 1;
`;

export const CardHead = styled.div`
  display: flex;
  gap: 2px;
  flex-direction: column;
`;

export const CardAddress = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const ProjectObjectsButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 9px 14px;
  border: 2px solid ${COLORS['primary/600']};
  border-radius: 6px;
  background: ${COLORS.white};
  color: ${COLORS['primary/600']};
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  white-space: nowrap;
  text-decoration: none;
  cursor: pointer;
  transition:
    background 0.2s ease,
    color 0.2s ease;
  &:hover {
    background: ${COLORS['primary/600']};
    color: #ffffff;
    svg path {
      stroke: #ffffff;
    }
  }
  &:active {
    opacity: 0.85;
  }
`;

export const StyledButton = styled.button<{ $isActive: boolean }>`
  && {
    border: none;
    outline: none;
    border-radius: 6px;
    width: 32px;
    height: 32px;
    padding: 0;
    min-width: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${COLORS['neutral/300']};
    cursor: pointer;
    background: ${({ $isActive }) => ($isActive ? '#ffffff80' : '#151B2850')} !important;
    &:hover {
      background: ${({ $isActive }) => ($isActive ? '#ffffffa0' : '#151B2870')} !important;
      svg {
        transform: scale(1.15);
      }
    }
    svg {
      transition:
        transform 0.22s cubic-bezier(0.2, 0.8, 0.2, 1),
        fill 0.22s ease,
        stroke 0.22s ease;
    }
  }
`;
